import { Modal } from '@surecompanies/core_components'
import React from 'react'
import { PAUSE_COLOR, solidButtonStyle } from './pauseResumeStyles'

type PauseEnrollmentModalProps = {
  open: boolean
  onConfirm: () => void
  onClose: () => void
  confirmLoading: boolean
}

export default function PauseEnrollmentModal({
  open,
  onConfirm,
  onClose,
  confirmLoading,
}: PauseEnrollmentModalProps) {
  return (
    <Modal
      open={open}
      title="Pause Enrollment For All Employees"
      onOk={onConfirm}
      onCancel={onClose}
      confirmLoading={confirmLoading}
      okText="Pause Enrollment"
      okButtonProps={{ style: solidButtonStyle(PAUSE_COLOR) }}
    >
      <p>
        Are you sure you want to pause enrollment for all employees? This will
        prevent any employee from making changes.
      </p>
    </Modal>
  )
}
